
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component
export default class Login extends Vue {
	@Action private serverLogout: () => Promise<void>;
	@Action private logout: () => void;

	private async created(): Promise<void> {
		await this.serverLogout();
		this.logout();
	}
}
